export default class TsdiClientInfo {
    clientNumber: number;
    dayRate?: number;
    mileageRate?: number;
    clientName: string;
    address?: string;
    address2?: string;
    address3?: string;
    country?: string;
    city?: string;
    state?: string;
    zipCode?: number;
    phone?: string;
    fax?: string;
    emailAddress?: string;
    masterServicesAgreement?: boolean;
    masterServicesAgreementDate?: Date;
    subConsultantAgreement?: boolean;
    useBillingAddress?: boolean;
    billingClientName?: string;
    billingAddress?: string;
    billingAddress2?: string;
    billingAddress3?: string;
    billingCountry?: string;
    billingCity?: string;
    billingState?: string;
    billingZipCode?: number;
    attachedDocuments?: number;
    noGiftPolicy?: boolean;
    workOrderRequired?: boolean;
    partnerAgreementRequired?: boolean;
    ndaRequired?: boolean;
    clientFormatType?: string;
}


// WEBPACK FOOTER //
// ./src/models/AP/ClientInfo.ts